<template>
  <div>
    <Breadcrumbs :items="breadcrumbs" page_title="notification" />

    <v-row class="ml-2 mr-2">
      <v-card
              width="1580"
              height="70"
              style="border-radius: 16px; display: flex; justify-content: flex-start; align-items: center;"
              class="ml-2 mt-2"
            >
              <div>
                <p style="font-size: 20px; color: #424242; text-align: left;" class="mt-0 ml-5">
                  Choose the language for sending emails.
                </p>
              </div>
              <div class="ml-2 mt-1">
                <v-radio-group v-model="selectedUserRadio">
                  <v-row class="ma-0 pa-0" no-gutters>
                    <v-col cols="auto" class="d-flex align-center">
                    
                      <div style="display: flex; align-items: center;">
                        <v-radio value="thai" class="mr-2 mt-2 ml-0"></v-radio>
                        <v-img
                          src="@/assets/thailandflag.svg"
                          width="35"
                          height="22"
                          contain
                        ></v-img>
                      </div>
                    </v-col>

                    <v-col cols="auto" class="d-flex align-center ml-2">
                    
                      <div style="display: flex; align-items: center;">
                        <v-radio value="eng" class="mr-2 mt-2"></v-radio>
                        <v-img
                          src="@/assets/ukflag.svg"
                          width="35"
                          height="22"
                          contain
                        ></v-img>
                      </div>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </div>
            </v-card>
       </v-row>
    <v-container fluid class="mt-3">
      <!-- New UI -->
       
      <v-row >
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="noti-icon" height="70px">
              <v-icon style="font-size: 30px">mdi-file-document</v-icon>
              <p class="title_style">{{ $t("libraryArticle") }}</p>
              <v-spacer></v-spacer>
              <div class="onoffswitch mt-3 ml-5">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch1"
                  :disabled="disable"
                  @input="Show_correctAns_switch(carddisable)"
                  v-model="carddisable"
                />
                <label class="onoffswitch-label" for="myonoffswitch1">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && carddisable == true ? false : true
                    "
                    color="#a6cc39"
                    v-model="article_endDate.beforeEnd"
                    @click="checkarticle_endDate(article_endDate.beforeEnd)"
                  >
                    <template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeEndDate") }}
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model.number="article_endDate.beforeEndDate"
                    dense
                    :disabled="
                      disable == false && carddisable == true ? false : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                    type="number"
                    min="0"
                    @keypress="isNumber($event)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="article_endDate.inbox"
                    :label="$t('inbox')"
                    color="#a6cc39"
                    :disabled="
                      article_endDate.inboxdisable == false &&
                      carddisable == true
                        ? false
                        : true
                    "
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="article_endDate.pushnoti"
                    color="#a6cc39"
                    class="chk-input"
                    :disabled="
                      article_endDate.pushnotidisable == false &&
                      carddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="article_endDate.email"
                    color="#a6cc39"
                    :disabled="
                      article_endDate.emaildisable == false &&
                      carddisable == true
                        ? false
                        : true
                    "
                    :label="$t('email')"
                    class="chk-input"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && carddisable == true ? false : true
                    "
                    color="#a6cc39"
                    v-model="article_expDate.beforeExp"
                    @click="checkarticle_expireDate(article_expDate.beforeExp)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeExpDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="article_expDate.beforeExpDate"
                    dense
                    :disabled="
                      disable == false && carddisable == true ? false : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="article_expDate.inbox"
                    :label="$t('inbox')"
                    color="#a6cc39"
                    :disabled="
                      article_expDate.inboxdisable == false &&
                      carddisable == true
                        ? false
                        : true
                    "
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="article_expDate.pushnoti"
                    color="#a6cc39"
                    :disabled="
                      article_expDate.pushnotidisable == false &&
                      carddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="article_expDate.email"
                    class="chk-input"
                    color="#a6cc39"
                    :disabled="
                      article_expDate.emaildisable == false &&
                      carddisable == true
                        ? false
                        : true
                    "
                    :label="$t('email')"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="noti-icon" height="70px">
              <v-icon style="font-size: 30px">mdi-volume-high</v-icon>
              <p class="title_style">{{ $t("librarySound") }}</p>

              <v-spacer></v-spacer>
              <div class="onoffswitch mt-3 ml-5">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch2"
                  :disabled="disable"
                  @input="Show_Sound_switch(soundcarddisable)"
                  v-model="soundcarddisable"
                />
                <label class="onoffswitch-label" for="myonoffswitch2">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && soundcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    v-model="sound_endDate.beforeEnd"
                    @click="checksound_endDate(sound_endDate.beforeEnd)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeEndDate") }}
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="sound_endDate.beforeEndDate"
                    dense
                    :disabled="
                      disable == false && soundcarddisable == true
                        ? false
                        : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                    type="number"
                    min="0"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="sound_endDate.inbox"
                    :label="$t('inbox')"
                    :disabled="
                      sound_endDate.inboxdisable == false &&
                      soundcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="sound_endDate.pushnoti"
                    color="#a6cc39"
                    class="chk-input"
                    :disabled="
                      sound_endDate.pushnotidisable == false &&
                      soundcarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="sound_endDate.email"
                    color="#a6cc39"
                    :label="$t('email')"
                    :disabled="
                      sound_endDate.emaildisable == false &&
                      soundcarddisable == true
                        ? false
                        : true
                    "
                    class="chk-input"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && soundcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    v-model="sound_expDate.beforeExp"
                    @click="checksound_expireDate(sound_expDate.beforeExp)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeExpDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="sound_expDate.beforeExpDate"
                    dense
                    :disabled="
                      disable == false && soundcarddisable == true
                        ? false
                        : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="sound_expDate.inbox"
                    :label="$t('inbox')"
                    :disabled="
                      sound_expDate.inboxdisable == false &&
                      soundcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="sound_expDate.pushnoti"
                    color="#a6cc39"
                    :disabled="
                      sound_expDate.pushnotidisable == false &&
                      soundcarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="sound_expDate.email"
                    class="chk-input"
                    color="#a6cc39"
                    :disabled="
                      sound_expDate.emaildisable == false &&
                      soundcarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('email')"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="noti-icon" height="70px">
              <v-img
                src="@/assets/images/video_img_black.svg"
                max-width="28"
                height="28"
                class="mr-2"
              ></v-img>
              <p class="title_style">{{ $t("library-video") }}</p>

              <v-spacer></v-spacer>
              <div class="onoffswitch mt-3 ml-5">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch3"
                  :disabled="disable"
                  @input="Show_Video_switch(videocarddisable)"
                  v-model="videocarddisable"
                />
                <label class="onoffswitch-label" for="myonoffswitch3">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && videocarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    v-model="video_endDate.beforeEnd"
                    @click="checkvideo_endDate(video_endDate.beforeEnd)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeEndDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="video_endDate.beforeEndDate"
                    dense
                    :disabled="
                      disable == false && videocarddisable == true
                        ? false
                        : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                    type="number"
                    min="0"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="video_endDate.inbox"
                    :label="$t('inbox')"
                    color="#a6cc39"
                    :disabled="
                      video_endDate.inboxdisable == false &&
                      videocarddisable == true
                        ? false
                        : true
                    "
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="video_endDate.pushnoti"
                    color="#a6cc39"
                    class="chk-input"
                    :disabled="
                      video_endDate.pushnotidisable == false &&
                      videocarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="video_endDate.email"
                    color="#a6cc39"
                    :disabled="
                      video_endDate.emaildisable == false &&
                      videocarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('email')"
                    class="chk-input"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && videocarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    v-model="video_expDate.beforeExp"
                    @click="checkvideo_expireDate(video_expDate.beforeExp)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeExpDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="video_expDate.beforeExpDate"
                    dense
                    :disabled="
                      disable == false && videocarddisable == true
                        ? false
                        : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="video_expDate.inbox"
                    :label="$t('inbox')"
                    color="#a6cc39"
                    :disabled="
                      video_expDate.inboxdisable == false &&
                      videocarddisable == true
                        ? false
                        : true
                    "
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    :disabled="
                      video_expDate.pushnotidisable == false &&
                      videocarddisable == true
                        ? false
                        : true
                    "
                    v-model="video_expDate.pushnoti"
                    color="#a6cc39"
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="video_expDate.email"
                    class="chk-input"
                    color="#a6cc39"
                    :disabled="
                      video_expDate.emaildisable == false &&
                      videocarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('email')"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="noti-icon" height="70px">
              <v-img
                src="@/assets/images/book_img.svg"
                max-width="23"
                height="23"
                class="mr-3"
              ></v-img>
              <p class="title_style">{{ $t("lessonlearn") }}</p>
              <v-spacer></v-spacer>
              <div class="onoffswitch mt-3 ml-5">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch4"
                  :disabled="disable"
                  @input="Show_Lesson_switch(llcarddisable)"
                  v-model="llcarddisable"
                />
                <label class="onoffswitch-label" for="myonoffswitch4">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && llcarddisable == true ? false : true
                    "
                    color="#a6cc39"
                    v-model="lessonlearn_endDate.beforeEnd"
                    @click="
                      checklessonlearn_endDate(lessonlearn_endDate.beforeEnd)
                    "
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeEndDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="lessonlearn_endDate.beforeEndDate"
                    dense
                    :disabled="
                      disable == false && llcarddisable == true ? false : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                    type="number"
                    min="0"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="lessonlearn_endDate.inbox"
                    :label="$t('inbox')"
                    color="#a6cc39"
                    :disabled="
                      lessonlearn_endDate.inboxdisable == false &&
                      llcarddisable == true
                        ? false
                        : true
                    "
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="lessonlearn_endDate.pushnoti"
                    color="#a6cc39"
                    class="chk-input"
                    :disabled="
                      lessonlearn_endDate.pushnotidisable == false &&
                      llcarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="lessonlearn_endDate.email"
                    color="#a6cc39"
                    :label="$t('email')"
                    :disabled="
                      lessonlearn_endDate.emaildisable == false &&
                      llcarddisable == true
                        ? false
                        : true
                    "
                    class="chk-input"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && llcarddisable == true ? false : true
                    "
                    color="#a6cc39"
                    v-model="lessonlearn_expDate.beforeExp"
                    @click="
                      checklessonlearn_expireDate(lessonlearn_expDate.beforeExp)
                    "
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeExpDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="lessonlearn_expDate.beforeExpDate"
                    dense
                    :disabled="
                      disable == false && llcarddisable == true ? false : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="lessonlearn_expDate.inbox"
                    :label="$t('inbox')"
                    :disabled="
                      lessonlearn_expDate.inboxdisable == false &&
                      llcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="lessonlearn_expDate.pushnoti"
                    color="#a6cc39"
                    :disabled="
                      lessonlearn_expDate.pushnotidisable == false &&
                      llcarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="lessonlearn_expDate.email"
                    class="chk-input"
                    :disabled="
                      lessonlearn_expDate.emaildisable == false &&
                      llcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    :label="$t('email')"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="noti-icon" height="70px">
              <v-icon style="font-size: 30px" class="mr-2"
                >mdi-pencil-minus</v-icon
              >
              <p class="title_style">{{ $t("assignmentcourse") }}</p>
              <v-spacer></v-spacer>
              <div class="onoffswitch mt-3 ml-5">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch5"
                  :disabled="disable"
                  @input="Show_Assignment_switch(accarddisable)"
                  v-model="accarddisable"
                />
                <label class="onoffswitch-label" for="myonoffswitch5">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && accarddisable == true ? false : true
                    "
                    color="#a6cc39"
                    v-model="AC_endDate.beforeEnd"
                    @click="checkac_endDate(AC_endDate.beforeEnd)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeEndDate") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="AC_endDate.beforeEndDate"
                    dense
                    :disabled="
                      disable == false && accarddisable == true ? false : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                    type="number"
                    min="0"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="AC_endDate.inbox"
                    :label="$t('inbox')"
                    :disabled="
                      AC_endDate.inboxdisable == false && accarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="AC_endDate.pushnoti"
                    color="#a6cc39"
                    :disabled="
                      AC_endDate.pushnotidisable == false &&
                      accarddisable == true
                        ? false
                        : true
                    "
                    class="chk-input"
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="AC_endDate.email"
                    color="#a6cc39"
                    :disabled="
                      AC_endDate.emaildisable == false && accarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('email')"
                    class="chk-input"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="noti-icon" height="70px">
              <v-icon style="font-size: 30px" class="mr-2"
                >mdi-calendar-month</v-icon
              >
              <p class="title_style">{{ $t("event") }}</p>
              <v-spacer></v-spacer>
              <div class="onoffswitch mt-3 ml-5">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch6"
                  :disabled="disable"
                  @input="Show_Event_switch(eventcarddisable)"
                  v-model="eventcarddisable"
                />
                <label class="onoffswitch-label" for="myonoffswitch6">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="d-flex">
                <v-col>
                  <v-checkbox
                    value
                    :disabled="
                      disable == false && eventcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    v-model="event_endDate.beforeEnd"
                    @click="checkevent_endDate(event_endDate.beforeEnd)"
                    ><template v-slot:label>
                      <div class="subtitle">
                        {{ $t("beforeevent") }}
                      </div>
                    </template></v-checkbox
                  >
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="event_endDate.beforeEndDate"
                    dense
                    :disabled="
                      disable == false && eventcarddisable == true
                        ? false
                        : true
                    "
                    class="input-field"
                    outlined
                    hide-details="auto"
                    type="number"
                    min="0"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 divide">
                <v-col>
                  <v-checkbox
                    class="chk-input"
                    v-model="event_endDate.inbox"
                    :label="$t('inbox')"
                    :disabled="
                      event_endDate.inboxdisable == false &&
                      eventcarddisable == true
                        ? false
                        : true
                    "
                    color="#a6cc39"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="event_endDate.pushnoti"
                    color="#a6cc39"
                    class="chk-input"
                    :disabled="
                      event_endDate.pushnotidisable == false &&
                      eventcarddisable == true
                        ? false
                        : true
                    "
                    :label="$t('pushnotification')"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="event_endDate.email"
                    color="#a6cc39"
                    :label="$t('email')"
                    :disabled="
                      event_endDate.emaildisable == false &&
                      eventcarddisable == true
                        ? false
                        : true
                    "
                    class="chk-input"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- end of New UI -->

      <v-row class="ma-8 d-flex justify-end" v-if="disable">
        <v-btn
          width="110"
          @click="Edit()"
          class="text-capitalize btnStyle"
          color="secondary"
          ><v-icon class="mr-2">mdi-square-edit-outline</v-icon
          >{{ $t("edit") }}</v-btn
        >
      </v-row>
      <v-row v-else class="ma-8 d-flex justify-end">
        <v-btn
          outlined
          class="mr-3"
          text
          @click="Cancel()"
          style="font-size: 18px; background: #ffffff"
          >{{ $t("cancel") }}</v-btn
        >
        <v-btn
          width="110"
          @click="(disable = true), CreateOrUpdateSettingNotification()"
          class="text-capitalize btnStyle"
          color="secondary"
          ><v-icon class="mr-2">mdi-content-save-outline</v-icon
          >{{ $t("save") }}</v-btn
        >
      </v-row>
    </v-container>
    <PermissionDialog
      :show="permissionDialog"
      title="Error"
      :text="permissionMessage"
      @close="permissionDialog = false"
    />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    selectedUserRadio: "thai",
    permissionDialog: false,
    permissionMessage: "",
    carddisable: false,
    soundcarddisable: false,
    videocarddisable: false,
    llcarddisable: false,
    accarddisable: false,
    eventcarddisable: false,
    showCorrectAnswer: false,

    lock: false,
    breadcrumbs: [
      {
        sidebar_tilte: "home",
      },
      {
        text: "notification",
      },
    ],
    disable: true,
    article_endDate: {
      beforeEnd: false,
      beforeEndDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    article_expDate: {
      beforeExp: false,
      beforeExpDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    sound_endDate: {
      beforeEnd: false,
      beforeEndDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    sound_expDate: {
      beforeExp: false,
      beforeExpDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    video_endDate: {
      beforeEnd: false,
      beforeEndDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    video_expDate: {
      beforeExp: false,
      beforeExpDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    lessonlearn_endDate: {
      beforeEnd: false,
      beforeEndDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    lessonlearn_expDate: {
      beforeExp: false,
      beforeExpDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    AC_endDate: {
      beforeEnd: false,
      beforeEndDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    event_endDate: {
      beforeEnd: false,
      beforeEndDate: null,
      inbox: false,
      pushnoti: false,
      email: false,
      inboxdisable: true,
      pushnotidisable: true,
      emaildisable: true,
    },
    CreateDate: "",
    CreateBy: "",
  }),
  mounted() {
    this.GetSettingNotification();
  },
  methods: {
    Show_correctAns_switch(v) {
      if (v) {
        this.article_endDate.inboxdisable = false;
      }
    },
    Show_Sound_switch(v) {
      if (v) {
        this.sound_endDate.inboxdisable = false;
      }
    },
    Show_Video_switch(v) {
      if (v) {
        this.video_endDate.inboxdisable = false;
      }
    },
    Show_Lesson_switch(v) {
      if (v) {
        this.lessonlearn_endDate.inboxdisable = false;
      }
    },
    Show_Assignment_switch(v) {
      if (v) {
        this.AC_endDate.inboxdisable = false;
      }
    },
    Show_Event_switch(v) {
      if (v) {
        this.event_endDate.inboxdisable = false;
      }
    },
    Cancel() {
      this.disable = true;
      this.lock = false;

      this.article_endDate.inboxdisable = true;
      this.article_endDate.pushnotidisable = true;
      this.article_endDate.emaildisable = true;

      this.article_expDate.inboxdisable = true;
      this.article_expDate.pushnotidisable = true;
      this.article_expDate.emaildisable = true;

      this.sound_endDate.inboxdisable = true;
      this.sound_endDate.pushnotidisable = true;
      this.sound_endDate.emaildisable = true;

      this.sound_expDate.inboxdisable = true;
      this.sound_expDate.pushnotidisable = true;
      this.sound_expDate.emaildisable = true;

      this.video_endDate.inboxdisable = true;
      this.video_endDate.pushnotidisable = true;
      this.video_endDate.emaildisable = true;

      this.video_expDate.inboxdisable = true;
      this.video_expDate.pushnotidisable = true;
      this.video_expDate.emaildisable = true;

      this.lessonlearn_endDate.inboxdisable = true;
      this.lessonlearn_endDate.pushnotidisable = true;
      this.lessonlearn_endDate.emaildisable = true;

      this.lessonlearn_expDate.inboxdisable = true;
      this.lessonlearn_expDate.pushnotidisable = true;
      this.lessonlearn_expDate.emaildisable = true;

      this.AC_endDate.inboxdisable = true;
      this.AC_endDate.pushnotidisable = true;
      this.AC_endDate.emaildisable = true;

      this.event_endDate.inboxdisable = true;
      this.event_endDate.pushnotidisable = true;
      this.event_endDate.emaildisable = true;
    },
    Edit() {

      let checkPermission = this.check_Permissions("notification");
      if (checkPermission === false) {
        this.permissionDialog = true;
        this.permissionMessage =
          "You don't have permission to edit Setting-Notification.";
        return false;
      }

      this.disable = false;
      this.checkarticle_endDate(this.article_endDate.beforeEnd);
      this.checkarticle_expireDate(this.article_expDate.beforeExp);
      this.checksound_endDate(this.sound_endDate.beforeEnd);
      this.checksound_expireDate(this.sound_expDate.beforeExp);
      this.checkvideo_endDate(this.video_endDate.beforeEnd);
      this.checkvideo_expireDate(this.video_expDate.beforeExp);
      this.checklessonlearn_endDate(this.lessonlearn_endDate.beforeEnd);
      this.checklessonlearn_expireDate(this.lessonlearn_expDate.beforeExp);
      this.checkac_endDate(this.AC_endDate.beforeEnd);
      this.checkevent_endDate(this.event_endDate.beforeEnd);
    },
    checkarticle_endDate(item) {
      if (item) {
        this.article_endDate.inboxdisable = false;
        this.article_endDate.pushnotidisable = false;
        this.article_endDate.emaildisable = false;
      } else {
        this.article_endDate.inboxdisable = true;
        this.article_endDate.pushnotidisable = true;
        this.article_endDate.emaildisable = true;
        this.article_endDate.inbox = false;
        this.article_endDate.pushnoti = false;
        this.article_endDate.email = false;
      }
    },
    checkarticle_expireDate(item) {
      if (item) {
        this.article_expDate.inboxdisable = false;
        this.article_expDate.pushnotidisable = false;
        this.article_expDate.emaildisable = false;
      } else {
        this.article_expDate.inboxdisable = true;
        this.article_expDate.pushnotidisable = true;
        this.article_expDate.emaildisable = true;
        this.article_expDate.inbox = false;
        this.article_expDate.pushnoti = false;
        this.article_expDate.email = false;
      }
    },
    checksound_endDate(item) {
      if (item) {
        this.sound_endDate.inboxdisable = false;
        this.sound_endDate.pushnotidisable = false;
        this.sound_endDate.emaildisable = false;
      } else {
        this.sound_endDate.inboxdisable = true;
        this.sound_endDate.pushnotidisable = true;
        this.sound_endDate.emaildisable = true;
        this.sound_endDate.inbox = false;
        this.sound_endDate.pushnoti = false;
        this.sound_endDate.email = false;
      }
    },
    checksound_expireDate(item) {
      if (item) {
        this.sound_expDate.inboxdisable = false;
        this.sound_expDate.pushnotidisable = false;
        this.sound_expDate.emaildisable = false;
      } else {
        this.sound_expDate.inboxdisable = true;
        this.sound_expDate.pushnotidisable = true;
        this.sound_expDate.emaildisable = true;
        this.sound_expDate.inbox = false;
        this.sound_expDate.pushnoti = false;
        this.sound_expDate.email = false;
      }
    },
    checkvideo_endDate(item) {
      if (item) {
        this.video_endDate.inboxdisable = false;
        this.video_endDate.pushnotidisable = false;
        this.video_endDate.emaildisable = false;
      } else {
        this.video_endDate.inboxdisable = true;
        this.video_endDate.pushnotidisable = true;
        this.video_endDate.emaildisable = true;
        this.video_endDate.inbox = false;
        this.video_endDate.pushnoti = false;
        this.video_endDate.email = false;
      }
    },
    checkvideo_expireDate(item) {
      if (item) {
        this.video_expDate.inboxdisable = false;
        this.video_expDate.pushnotidisable = false;
        this.video_expDate.emaildisable = false;
      } else {
        this.video_expDate.inboxdisable = true;
        this.video_expDate.pushnotidisable = true;
        this.video_expDate.emaildisable = true;
        this.video_expDate.inbox = false;
        this.video_expDate.pushnoti = false;
        this.video_expDate.email = false;
      }
    },
    checklessonlearn_endDate(item) {
      if (item) {
        this.lessonlearn_endDate.inboxdisable = false;
        this.lessonlearn_endDate.pushnotidisable = false;
        this.lessonlearn_endDate.emaildisable = false;
      } else {
        this.lessonlearn_endDate.inboxdisable = true;
        this.lessonlearn_endDate.pushnotidisable = true;
        this.lessonlearn_endDate.emaildisable = true;
        this.lessonlearn_endDate.inbox = false;
        this.lessonlearn_endDate.pushnoti = false;
        this.lessonlearn_endDate.email = false;
      }
    },
    checklessonlearn_expireDate(item) {
      if (item) {
        this.lessonlearn_expDate.inboxdisable = false;
        this.lessonlearn_expDate.pushnotidisable = false;
        this.lessonlearn_expDate.emaildisable = false;
      } else {
        this.lessonlearn_expDate.inboxdisable = true;
        this.lessonlearn_expDate.pushnotidisable = true;
        this.lessonlearn_expDate.emaildisable = true;
        this.lessonlearn_expDate.inbox = false;
        this.lessonlearn_expDate.pushnoti = false;
        this.lessonlearn_expDate.email = false;
      }
    },
    checkac_endDate(item) {
      if (item) {
        this.AC_endDate.inboxdisable = false;
        this.AC_endDate.pushnotidisable = false;
        this.AC_endDate.emaildisable = false;
      } else {
        this.AC_endDate.inboxdisable = true;
        this.AC_endDate.pushnotidisable = true;
        this.AC_endDate.emaildisable = true;
        this.AC_endDate.inbox = false;
        this.AC_endDate.pushnoti = false;
        this.AC_endDate.email = false;
      }
    },
    checkevent_endDate(item) {
      if (item) {
        this.event_endDate.inboxdisable = false;
        this.event_endDate.pushnotidisable = false;
        this.event_endDate.emaildisable = false;
      } else {
        this.event_endDate.inboxdisable = true;
        this.event_endDate.pushnotidisable = true;
        this.event_endDate.emaildisable = true;
        this.event_endDate.inbox = false;
        this.event_endDate.pushnoti = false;
        this.event_endDate.email = false;
      }
    },
    isNumber(evt) {
      const keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ".",
      ];
      const keyPressed = evt.key;
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },
    async GetSettingNotification() {
      await axios
        .get(
          `${this.web_url}SendNotification/GetDataSettingNotification?CompanyID=` +
            localStorage.getItem("companyID")
        )
        .then((response) => {
          if (response.data.status == 0) {
            if (response.data.data != null) {
              this.selectedUserRadio = response.data.data.emailLanguage;
              this.carddisable = response.data.data.articleFlag;
              this.article_endDate.beforeEnd =
                response.data.data.articleBEndFlag;
              this.article_endDate.beforeEndDate =
                response.data.data.articleBEndDay;
              this.article_endDate.inbox = response.data.data.articleBEndInbox;
              this.article_endDate.pushnoti =
                response.data.data.articleBEndPushNoti;
              this.article_endDate.email = response.data.data.articleBEndEmail;

              this.article_expDate.beforeExp =
                response.data.data.articleBExpFlag;
              this.article_expDate.beforeExpDate =
                response.data.data.articleBExpDay;
              this.article_expDate.inbox = response.data.data.articleBExpInbox;
              this.article_expDate.pushnoti =
                response.data.data.articleBExpPushNoti;
              this.article_expDate.email = response.data.data.articleBExpEmail;

              this.soundcarddisable = response.data.data.soundFlag;
              this.sound_endDate.beforeEnd = response.data.data.soundBEndFlag;
              this.sound_endDate.beforeEndDate =
                response.data.data.soundBEndDay;
              this.sound_endDate.inbox = response.data.data.soundBEndInbox;
              this.sound_endDate.pushnoti =
                response.data.data.soundBEndPushNoti;
              this.sound_endDate.email = response.data.data.soundBEndEmail;

              this.sound_expDate.beforeExp = response.data.data.soundBExpFlag;
              this.sound_expDate.beforeExpDate =
                response.data.data.soundBExpDay;
              this.sound_expDate.inbox = response.data.data.soundBExpInbox;
              this.sound_expDate.pushnoti =
                response.data.data.soundBExpPushNoti;
              this.sound_expDate.email = response.data.data.soundBExpEmail;

              this.videocarddisable = response.data.data.videoFlag;
              this.video_endDate.beforeEnd = response.data.data.videoBEndFlag;
              this.video_endDate.beforeEndDate =
                response.data.data.videoBEndDay;
              this.video_endDate.inbox = response.data.data.videoBEndInbox;
              this.video_endDate.pushnoti =
                response.data.data.videoBEndPushNoti;
              this.video_endDate.email = response.data.data.videoBEndEmail;

              this.video_expDate.beforeExp = response.data.data.videoBExpFlag;
              this.video_expDate.beforeExpDate =
                response.data.data.videoBExpDay;
              this.video_expDate.inbox = response.data.data.videoBExpInbox;
              this.video_expDate.pushnoti =
                response.data.data.videoBExpPushNoti;
              this.video_expDate.email = response.data.data.videoBExpEmail;

              this.llcarddisable = response.data.data.lessonLearnFlag;
              this.lessonlearn_endDate.beforeEnd =
                response.data.data.lessonLearnBEndFlag;
              this.lessonlearn_endDate.beforeEndDate =
                response.data.data.lessonLearnBEndDay;
              this.lessonlearn_endDate.inbox =
                response.data.data.lessonLearnBEndInbox;
              this.lessonlearn_endDate.pushnoti =
                response.data.data.lessonLearnBEndPushNoti;
              this.lessonlearn_endDate.email =
                response.data.data.lessonLearnBEndEmail;

              this.lessonlearn_expDate.beforeExp =
                response.data.data.lessonLearnBExpFlag;
              this.lessonlearn_expDate.beforeExpDate =
                response.data.data.lessonLearnBExpDay;
              this.lessonlearn_expDate.inbox =
                response.data.data.lessonLearnBExpInbox;
              this.lessonlearn_expDate.pushnoti =
                response.data.data.lessonLearnBExpPushNoti;
              this.lessonlearn_expDate.email =
                response.data.data.lessonLearnBExpEmail;

              this.accarddisable = response.data.data.assignmentCourseFlag;
              this.AC_endDate.beforeEnd =
                response.data.data.assignmentCourseBEndFlag;
              this.AC_endDate.beforeEndDate =
                response.data.data.assignmentCourseBEndDay;
              this.AC_endDate.inbox =
                response.data.data.assignmentCourseBEndInbox;
              this.AC_endDate.pushnoti =
                response.data.data.assignmentCourseBEndPushNoti;
              this.AC_endDate.email =
                response.data.data.assignmentCourseBEndEmail;

              this.eventcarddisable = response.data.data.eventFlag;
              this.event_endDate.beforeEnd = response.data.data.eventBStartFlag;
              this.event_endDate.beforeEndDate =
                response.data.data.eventBStartDay;
              this.event_endDate.inbox = response.data.data.eventBStartInbox;
              this.event_endDate.pushnoti =
                response.data.data.eventBStartPushNoti;
              this.event_endDate.email = response.data.data.eventBStartEmail;
              this.CreateDate = response.data.data.createDate;
              this.CreateBy = response.data.data.createBy;
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    async CreateOrUpdateSettingNotification() {
      this.loading = true;
      let request = {
        CompanyID: localStorage.getItem("companyID"),
        emailLanguage: this.selectedUserRadio,
        ArticleFlag: this.carddisable,
        ArticleBEndFlag: this.article_endDate.beforeEnd,
        ArticleBEndDay: parseInt(this.article_endDate.beforeEndDate),
        ArticleBEndInbox: this.article_endDate.inbox,
        ArticleBEndPushNoti: this.article_endDate.pushnoti,
        ArticleBEndEmail: this.article_endDate.email,
        ArticleBExpFlag: this.article_expDate.beforeExp,
        ArticleBExpDay: parseInt(this.article_expDate.beforeExpDate),
        ArticleBExpInbox: this.article_expDate.inbox,
        ArticleBExpPushNoti: this.article_expDate.pushnoti,
        ArticleBExpEmail: this.article_expDate.email,
        SoundFlag: this.soundcarddisable,
        SoundBEndFlag: this.sound_endDate.beforeEnd,
        SoundBEndDay: parseInt(this.sound_endDate.beforeEndDate),
        SoundBEndInbox: this.sound_endDate.inbox,
        SoundBEndPushNoti: this.sound_endDate.pushnoti,
        SoundBEndEmail: this.sound_endDate.email,
        SoundBExpFlag: this.sound_expDate.beforeExp,
        SoundBExpDay: parseInt(this.sound_expDate.beforeExpDate),
        SoundBExpInbox: this.sound_expDate.inbox,
        SoundBExpPushNoti: this.sound_expDate.pushnoti,
        SoundBExpEmail: this.sound_expDate.email,
        VideoFlag: this.videocarddisable,
        VideoBEndFlag: this.video_endDate.beforeEnd,
        VideoBEndDay: parseInt(this.video_endDate.beforeEndDate),
        VideoBEndInbox: this.video_endDate.inbox,
        VideoBEndPushNoti: this.video_endDate.pushnoti,
        VideoBEndEmail: this.video_endDate.email,
        VideoBExpFlag: this.video_expDate.beforeExp,
        VideoBExpDay: parseInt(this.video_expDate.beforeExpDate),
        VideoBExpInbox: this.video_expDate.inbox,
        VideoBExpPushNoti: this.video_expDate.pushnoti,
        VideoBExpEmail: this.video_expDate.email,
        LessonLearnFlag: this.llcarddisable,
        LessonLearnBEndFlag: this.lessonlearn_endDate.beforeEnd,
        LessonLearnBEndDay: parseInt(this.lessonlearn_endDate.beforeEndDate),
        LessonLearnBEndInbox: this.lessonlearn_endDate.inbox,
        LessonLearnBEndPushNoti: this.lessonlearn_endDate.pushnoti,
        LessonLearnBEndEmail: this.lessonlearn_endDate.email,
        LessonLearnBExpFlag: this.lessonlearn_expDate.beforeExp,
        LessonLearnBExpDay: parseInt(this.lessonlearn_expDate.beforeExpDate),
        LessonLearnBExpInbox: this.lessonlearn_expDate.inbox,
        LessonLearnBExpPushNoti: this.lessonlearn_expDate.pushnoti,
        LessonLearnBExpEmail: this.lessonlearn_expDate.email,
        AssignmentCourseFlag: this.accarddisable,
        AssignmentCourseBEndFlag: this.AC_endDate.beforeEnd,
        AssignmentCourseBEndDay: parseInt(this.AC_endDate.beforeEndDate),
        AssignmentCourseBEndInbox: this.AC_endDate.inbox,
        AssignmentCourseBEndPushNoti: this.AC_endDate.pushnoti,
        AssignmentCourseBEndEmail: this.AC_endDate.email,
        EventFlag: this.eventcarddisable,
        EventBStartFlag: this.event_endDate.beforeEnd,
        EventBStartDay: parseInt(this.event_endDate.beforeEndDate),
        EventBStartInbox: this.event_endDate.inbox,
        EventBStartPushNoti: this.event_endDate.pushnoti,
        EventBStartEmail: this.event_endDate.email,
      };
      await axios
        .post(
          `${this.web_url}SendNotification/CreateOrUpdateSettingNotification`,
          request
        )
        .then((response) => {
          if (response.data.status == 0) {
            this.loading = false;
            this.Cancel();
          }
        })
        .catch((err) => {
          alert(err);
        });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.radio-group {
  display: flex;
  align-items: center;
}

.radio-wrapper {
  position: relative;
  width: 22px;
  height: 22px;
}

.radio-placeholder,
.radio-button {
  position: absolute;
  top: 2px;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.radio-placeholder {
  background-color:#424242;
  opacity: 0.1;
  pointer-events: none; /* Prevent interaction */
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
}

.title_style {
  color: #000000;
  font-size: 22px;
}
.subtitle {
  color: #47484b;
  font-size: 20px;
}
.text-style {
  color: #47484b;
  font-size: 18px;
}

::v-deep .chk-input .v-input__control {
  align-content: end;
}
::v-deep .chk-input .v-input__slot {
  width: 200px;
}
::v-deep .input-field .v-input__slot {
  width: 127px !important;
  margin-top: 12px;
  left: 60% !important;
}
.font-style {
  font-size: 16px;
  color: #000000;
}

::v-deep .btnStyle .v-btn__content {
  font-size: 20px;
  color: #fff;
}
.chk-class {
  margin-left: 30px;
}
.div-class {
  margin-left: 8rem;
  margin-top: 10px;
}
::v-deep
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(
    .v-input--has-state
  )
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #707070;
  background: white;
}
::v-deep
  .theme--light.v-text-field--outlined:not(
    .v-input--is-focused
  ).v-input--is-disabled
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #bbbbbb33;
  background: #bbbbbb33;
}
</style>

<style>
.v-card {
  border-radius: 18px !important;
  padding-bottom: 20px;
}
.noti-icon .v-icon {
  color: #424242 !important;
}
.v-application p {
  margin-bottom: 0px !important;
}
.divide {
  border-bottom: 1px solid #c0c0c0;
}
.v-input--switch--inset .v-input--selection-controls__input,
.v-input--switch--inset .v-input--switch__track {
  width: 70px !important;
  height: 31px !important;
}
.onoffswitch {
  position: relative;
  width: 73px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: 20px;
}

.onoffswitch-inner {
  width: 200%;
  margin-left: -100%;
  -moz-transition: margin 0.3s ease-in 0s;
  -webkit-transition: margin 0.3s ease-in 0s;
  -o-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before,
.onoffswitch-inner:after {
  float: left;
  width: 50%;
  height: 28px;
  padding: 0;
  line-height: 30px;
  font-size: 14px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "ON";
  padding-left: 11px;
  background-color: #6fdc42;
  color: #ffffff;
}

.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 11px;
  color: #ffffff;
  background-color: #707070;
  opacity: 1;
  text-align: right;
}

.onoffswitch-switch {
  width: 26px;
  height: 26px;
  margin: 1px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 44px;
  -moz-transition: all 0.3s ease-in 0s;
  -webkit-transition: all 0.3s ease-in 0s;
  -o-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}
</style>